<template>
    <div
        :class="{
            filter__item: true,
            [`filter__item--${filterType}`]: true,
        }"
    >
        <div class="filter__box">
            <div class="columns">
                <div class="column is-3-5">
                    <template v-if="filters.length">
                        <form-dropdown
                            id="dropdown-name"
                            :key="hideFilterHubSpot"
                            ref="selectizeName"
                            v-model="form.name"
                            :error="form.errors.get('name')"
                            :settings="settingSelectBoxFilter"
                            @input="handleNameFilter"
                        />
                    </template>
                </div>

                <div
                    v-if="showFilterOperators"
                    class="column"
                    :class="{
                        'is-3': !isEmpty && !isFilled,
                        'is-8': (isEmpty && isFilled) || isHiddenInputValue,
                    }"
                >
                    <form-dropdown
                        id="dropdown-operator"
                        v-model="form.operator"
                        :value="form.operator"
                        :error="form.errors.get('operator')"
                        :settings="settingSelectBox"
                    >
                        <option
                            v-for="(operator, index) in operators"
                            :key="`${operator.key}-${index}`"
                            :value="operator.key"
                        >
                            {{ operator.name }}
                        </option>
                    </form-dropdown>
                </div>

                <template v-if="filterType === 'integrations_hubspot'">
                    <div class="column is-8">
                        <form-dropdown
                            id="dropdown-type-integrations_hubspot"
                            ref="selectize"
                            :key="filterName"
                            dropdown-class="selectize-contacts hubspot-lists"
                            :settings="settingSelectHubSpotList"
                            @input="handleChangeHubSpotList"
                        />
                    </div>
                </template>

                <template v-if="filterType === 'tags'">
                    <div class="column s-5 column-multiSelect">
                        <tags ref="tags" :form="form" />
                    </div>
                </template>

                <template v-if="filterTypeDate">
                    <template v-if="isHiddenInputValue">
                        <form-input v-model="form.value" :form="form" type="hidden" />
                    </template>
                    <template v-else-if="checkOperator">
                        <div class="column is-5-5">
                            <div class="filter__number">
                                <div class="filter__number__text">days</div>
                                <form-input
                                    v-model="form.value"
                                    :form="form"
                                    :type="'number'"
                                    :error="form.errors.get('value')"
                                    :min="0"
                                />
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="column is-5-5">
                            <date-picker-custom
                                :type="typeDataPicker"
                                :isTime="
                                    filterType === 'date_time' ||
                                        filterType === 'date_time_shortcode'
                                "
                                :icon="['far', 'calendar']"
                                :date="form.value"
                                :checkEmpty="true"
                                @update-calendar="updateCalendar"
                            />
                        </div>
                    </template>
                </template>

                <template
                    v-if="
                        filterType === 'text' || filterType === 'url' || filterType === 'area_code'
                    "
                >
                    <template v-if="isHiddenInputValue">
                        <form-input v-model="form.value" :form="form" :type="'hidden'" />
                    </template>
                    <template v-else>
                        <div class="column is-5-5">
                            <form-input v-model="form.value" :form="form" :type="'text'" />
                        </div>
                    </template>
                </template>

                <template v-if="filterType === 'number'">
                    <template v-if="isHiddenInputValue">
                        <form-input v-model="form.value" :form="form" :type="'hidden'" />
                    </template>
                    <template v-else>
                        <div class="column is-5-5">
                            <form-input v-model="form.value" :form="form" :type="'number'" />
                        </div>
                    </template>
                </template>

                <template v-if="hasMultiSelect">
                    <div
                        v-if="!isHiddenInputValue"
                        class="column is-5-5 column-state column-multiSelect"
                    >
                        <form-dropdown
                            id="dropdown-name-array"
                            :key="filterName"
                            ref="selectize"
                            :settings="settingMultiSelectBoxInput"
                            @input="handleChangeMultiSelect"
                        />
                    </div>
                </template>

                <div
                    v-show="!hasHideForClose"
                    class="column is-1 filter__close"
                    :class="{ 'disabled-element': hasHideForClose }"
                >
                    <span @click="remove">
                        <fa-icon :icon="['far', 'times']" />
                    </span>
                </div>
            </div>
        </div>
        <div v-if="isAllowEmptyCheckbox" class="filter__box">
            <form-checkbox v-model="form.is_empty">
                Include records where "{{ filterLabel }}" is empty
            </form-checkbox>
        </div>
    </div>
</template>

<script>
import { mapState } from 'pinia';
import stores from 'store/modules';
import Form from 'core/Form';
import Tags from './Form/Tags';
import moment from 'moment';
import { sortBy as sortby, isEqual, differenceWith } from 'lodash';

export default {
    emits: ['toggleOperatorVisibility', 'handlerFirstFilterIntegration', 'choosenIntegrationFilters', 'removeFilter', 'changeValueFilter'],
    
    components: {
        Tags,
    },

    props: {
        dropdownClass: { type: String, default: '' },
        filtersList: { type: Array },
        filtersData: { type: Object },
        filter: { type: Object },
        isFilterEmpty: { type: Boolean },
        filterIndex: { type: Number, default: 0 },
        filtersIndex: { type: Number, default: 0 },
        disableSegment: { type: Boolean, default: true },
        name: { type: String, default: '' },
    },

    data() {
        return {
            filters: [],
            operators: [],
            typeDataPicker: null,
            form: new Form({
                name: '',
                operator: '',
                value: this.filter.type === 'opt_in' ? 1 : '',
                type: '',
                is_empty: false,
                tags: [],
                temporaryValue: '',
            }),
            initialize: true,
            hideFiltersData: false,
        };
    },

    computed: {
        hideFilterHubSpot() {
            if (this.name === 'broadcasts') {
                return 0;
            }
            let count = 0;
            const listLength = this.filtersList.map((list) => list.length);

            listLength.forEach((c) => {
                count += c;
            });

            return count > 1;
        },

        hasHideForClose() {
            return this.filtersIndex === 0 && this.filterIndex === 0;
        },

        filterLabel() {
            const filter = this.filters.find((item) => item.key === this.filterName);

            if (!filter) {
                return '';
            }

            return filter.name;
        },

        filterName() {
            return this.filter.name;
        },

        filterType() {
            if (this.filter.type === 'integrations_hubspot' && this.name !== 'broadcasts') {
                this.toggleOperatorVisibility(false);
            } else {
                this.toggleOperatorVisibility(true);
            }
            return this.filter.type;
        },

        filterTypeDate() {
            return Boolean(
                this.filterType === 'date' ||
                    this.filterType === 'date_time' ||
                    this.filterType === 'updated_created' ||
                    this.filterType === 'date_without_checkbox' ||
                    this.filterType === 'date_time_shortcode'
            );
        },

        filterOperator() {
            return this.form.operator;
        },

        filterValues() {
            const filter = this.filtersData.filters.find((item) => item.key === this.filter.name);

            if (!filter.values) return null;
            if (this.filter.name === 'state_code') {
                return sortby(filter.values, 'state_name')
                    .filter((item) => item.state_name && item.country_code)
                    .map((item) => {
                        const key = `${item.state_name}_${item.country_code}`.toLowerCase();

                        return {
                            key: key,
                            label: item.state_name,
                            value: item.state_code,
                        };
                    });
            }

            if (this.filter.name === 'country' || this.filter.name === 'time_zone') {
                return filter.values.map((item, i) => {
                    const key = `${item.key}_${i}`.toLowerCase();
                    return {
                        key,
                        label: item.label,
                        value: item.key,
                    };
                });
            }

            if (this.filter.name === 'source') {
                return filter.values.map((item) => ({
                    key: item.key,
                    label: item.label,
                    value: item.key,
                }));
            }

            return sortby(filter.values, 'label').map((item, i) => ({
                key: item.key,
                label: item.label,
                value: item.key,
            }));
        },

        hasMultiSelect() {
            return Boolean(this.filterValues);
        },

        settingSelectBox() {
            return {
                maxItems: 1,
                create: true,
                createOnBlur: true,
                dropdownParent: 'body',
                dropdownClass: `selectize-dropdown custom-select-box custom-select-box-filters ${this.dropdownClass}`,
            };
        },

        settingMultiSelectBoxInput() {
            return {
                valueField: 'value',
                searchField: ['label'],
                options: this.filterValues,
                highlight: true,
                render: {
                    item: this.dropdownItem,
                    option: this.dropdownOption,
                },
                maxItems: null,
                dropdownParent: 'body',
                dropdownClass: `selectize-dropdown custom-select-box custom-select-box-filters ${this.dropdownClass}`,
                plugins: ['remove_button'],
            };
        },

        settingSelectBoxFilter() {
            const groups = [...new Set(this.filters.map((item) => item.class))]
                .map((item) => ({
                    value: item,
                    label: item.replace('_', ' '),
                }))
                .filter((item) => {
                    if (item.value === 'integrations') {
                        return !this.hideFilterHubSpot;
                    }

                    return true;
                });

            const filterOptions = this.filters.filter((item) => {
                let isFirstFilterIntegration = this.filtersList[0][0].name === 'integrations';

                if (this.filtersIndex === 0 && this.filterIndex === 0) return true;

                if (isFirstFilterIntegration) return item.key === 'integrations';

                return item.key !== 'integrations';
            });

            return {
                maxItems: 1,
                options: filterOptions,
                dropdownParent: 'body',
                valueField: 'key',
                highlight: true,
                dropdownClass: `selectize-dropdown custom-select-box custom-select-box-filters ${this.dropdownClass}`,
                render: {
                    item: (item, escape) => {
                        return `
                            <div>
                                ${escape(item.name)}
                            </div>
                        `;
                    },
                    option: (item, escape) => {
                        if (item.key === 'integrations' && this.hideFilterHubSpot) {
                            return '<div style="display: none;"></div>';
                        }

                        return `
                            <div>
                                ${escape(item.name)}
                            </div>
                        `;
                    },
                },
                optgroups: this.disableSegment && groups,
                optgroupField: 'class',
            };
        },

        showFilterOperators() {
            if (!Array.isArray(this.operators)) return false;
            if (this.filterType === 'integrations_hubspot') return false;
            return Boolean(this.operators.length);
        },

        isEmpty() {
            return this.filterOperator === 'is_empty';
        },

        isFilled() {
            return this.filterOperator === 'is_filled';
        },

        isHiddenInputValue() {
            return Boolean(
                this.filterOperator === 'is_empty' ||
                    this.filterOperator === 'is_filled' ||
                    this.filterOperator === 'is_known' ||
                    this.filterOperator === 'is_unknown' ||
                    this.filterOperator === 'last_week' ||
                    this.filterOperator === 'last_month'
            );
        },

        isAllowEmptyCheckbox() {
            if (this.operators) {
                const operator = this.operators.find((item) => item.key === this.filter.operator);
                if (!operator) {
                    return false;
                }
                return operator.allow_empty_checkbox;
            }

            return false;
        },

        checkOperator() {
            switch (this.filterOperator) {
                case 'is_last':
                case 'is_more_than':
                case 'is_less_than':
                case 'updated_in_last':
                case 'not_updated_in_last':
                    return true;
                default:
                    return false;
            }
        },

        selectize() {
            if (!this.$refs.selectize) return;

            return this.$refs.selectize.$refs.dropdown.$el.selectize;
        },

        typeDateFilter() {
            if (this.form.operator === 'is_not_between' || this.form.operator === 'is_between') {
                return 'range';
            }

            return 'single';
        },

        mappedSettingSelectHubSpotList() {
            return this.loadedHubSpotContactLists.map((item) => ({
                label: item.name,
                id: item.list_id,
                size: item.size,
            }));
        },

        settingSelectHubSpotList() {
            return {
                valueField: 'id',
                searchField: ['label'],
                options: this.mappedSettingSelectHubSpotList,
                highlight: true,
                render: {
                    item: this.hubSpotDropdownItem,
                    option: this.hubSpotDropdownOption,
                },
                maxItems: 1,
                dropdownParent: 'body',
            };
        },

        ...mapState(stores.Tags, ['tags']),
    },

    watch: {
        'form.name'(value) {
            if (this.initialize) return;

            const filter = this.filters.find((item) => item.key === value);
            const typeForOperator = filter.type === 'tags' ? 'filter_tags' : filter.type;

            this.operators = this.filtersData.operators[typeForOperator];
            this.filter.name = value;
            this.filter.type = filter.type;
            this.filter.filterType = filter.filterType;
            this.filter.value = '';
            this.form.operator = '';
            this.form.value = '';

            if (this.filter.name === 'integrations' && this.filterIndex === 0) {
                this.handlerFirstFilterIntegration(true);
            }

            if (this.filterType === 'tags') {
                this.form.tags = [];
            }

            if (this.operators) {
                setTimeout(() => {
                    this.form.operator = this.operators[0].key;
                }, 50);
            }
        },

        'form.operator'(value, oldValue) {
            if (this.initialize) return;

            if (value) {
                this.typeDataPicker = this.typeDateFilter;
                this.filter.operator = value;

                if (this.isHiddenInputValue) {
                    if (!this.form.temporaryValue) {
                        this.form.temporaryValue = this.form.value;
                    }
                    this.form.value = null;
                } else {
                    this.form.tags = [];

                    if (this.filterType === 'tags' && this.$refs.tags) {
                        this.$refs.tags.handleSetValue(this.form.tags);
                    }
                }

                if (this.form.temporaryValue && !this.isHiddenInputValue) {
                    let local = this;
                    let TMV = this.form.temporaryValue;
                    setTimeout(() => {
                        if (local.selectizeElement()) {
                            local.selectizeElement().setValue([...TMV]);
                        }
                    }, 50);
                    this.form.value = this.form.temporaryValue;
                    this.form.temporaryValue = '';
                }
                if (this.checkOperator) {
                    this.form.value = '';
                }
                if (this.checkOperatorCustom(oldValue) && !this.checkOperatorCustom(value)) {
                    this.form.value = '';
                }

                this.changeValueFilter('update_operation', {
                    update: this.isHiddenInputValue,
                });
            } else {
                this.filter.operator = value;
            }
        },

        'form.is_empty'(value) {
            this.filter.is_empty = value;

            this.changeValueFilter('update_is_empty');
        },

        'form.value'(value) {
            if (this.initialize) return;

            if (this.filterOperator) {
                this.form.value = value < 0 ? 0 : value;
                this.filter.value = value < 0 ? 0 : value;
            } else {
                this.filter.value = value;
            }

            this.changeValueFilter('update_value');
        },

        'form.tags'(newValue, oldValue) {
            if (this.initialize) return;

            let newValues = [];

            if (newValue.length > oldValue.length) {
                newValues = differenceWith(newValue, oldValue, isEqual);
            } else {
                newValues = differenceWith(oldValue, newValue, isEqual);
            }

            if (newValues.length) {
                this.filter.value = [];
                this.filter.value[this.filterIndex] = [];

                newValue.forEach((id) => {
                    const tag = this.tags.find((item) => item.id === +id);

                    if (!tag) return;

                    this.filter.value[this.filterIndex].push({
                        id: tag.id,
                        name: tag.name,
                    });
                });

                this.changeValueFilter('update_tags');
            }
        },
    },

    methods: {
        init() {
            const sort = {
                contact_fields: 0,
                custom_fields: 1,
                'geo-location': 2,
                activity: 3,
                numbers: 4,
                hubspot_lists_integrations: 5,
            };
            if (this.disableSegment) {
                this.filters = this.filtersData.filters.sort((a, b) => {
                    const aValue = sort[a.class];
                    const bValue = sort[b.class];
                    return aValue - bValue;
                });
            } else {
                this.filters = this.filtersData.filters;
            }
            this.operators = this.filtersData.operators[this.filter.type];
            this.initForm();
            this.initFilter();

            setTimeout(() => {
                this.initialize = false;
            }, 500);
        },

        toggleOperatorVisibility(status) {
            this.$emit('toggleOperatorVisibility', status);
        },

        handlerFirstFilterIntegration(status) {
            this.$emit('handlerFirstFilterIntegration', status);
        },

        handleNameFilter(data) {
            if (
                this.filterIndex === 0 &&
                this.filtersIndex === 0 &&
                this.filterName === 'integrations'
            ) {
                this.$rootEvents.$emit('handleIsFirstFilterIntegrationFilterItem', true);
            }

            if (
                this.filterIndex === 0 &&
                this.filtersIndex === 0 &&
                this.filterName !== 'integrations'
            ) {
                this.$rootEvents.$emit('handleIsFirstFilterIntegrationFilterItem', false);
            }

            if (
                this.name === 'broadcasts' &&
                this.filterIndex === 0 &&
                this.filtersIndex === 0 &&
                this.filterName !== 'integrations'
            ) {
                this.$rootEvents.$emit('handleClearFilters', 0, 0);
            }
        },

        selectizeElement() {
            if (!this.$refs.selectize) return;

            return this.$refs.selectize.$refs.dropdown.$el.selectize;
        },

        checkOperatorCustom(value) {
            switch (value) {
                case 'is_last':
                case 'is_more_than':
                case 'is_less_than':
                case 'updated_in_last':
                case 'not_updated_in_last':
                    return true;
                default:
                    return false;
            }
        },

        updateCalendar({ type, data }) {
            let format = 'YYYY-MM-DD';

            if (this.filterType === 'date_time' || this.filterType === 'date_time_shortcode') {
                format = 'YYYY-MM-DD:HH:mm';
            }

            if (type === 'range') {
                this.form.value = {
                    from: moment(data.start).format(format),
                    to: moment(data.end).format(format),
                };
            }

            if (type === 'single') {
                this.form.value = moment(data).format(format);
            }

            this.changeValueFilter('update_calendar');
        },

        handleChangeMultiSelect(data) {
            if (this.initialize) return;
            this.form.value = data;
        },

        handleChangeHubSpotList(data) {
            if (this.initialize) return;

            this.form.value = data;
            this.$emit('choosenIntegrationFilters', data);
        },

        initFilter() {
            const filter = this.filters.find((item) => item.key === this.form.name);
            const typeForOperator = filter.type === 'tags' ? 'filter_tags' : filter.type;

            this.operators = this.filtersData.operators[typeForOperator];
            this.typeDataPicker = this.typeDateFilter;
            this.filter.type = filter.type;
            this.filter.filterType = filter.filterType;
            this.filter.form = this.form;
        },

        initForm() {
            this.form.name = this.filter.name;
            this.form.operator = this.filter.operator;
            this.form.is_empty = this.filter.is_empty;

            if (Array.isArray(this.filter.value)) {
                if (this.filterType === 'tags') {
                    this.form.tags = this.filter.value.map((item) => item.map((o) => o.id + ''));
                }

                this.form.value = this.filter.value;

                if (this.selectize) {
                    this.selectize.setValue(this.form.value);
                }
            } else {
                this.form.value = this.filter.value;

                if (this.filterType === 'integrations_hubspot') {
                    if (this.selectize) {
                        this.selectize.setValue(this.form.value);
                    }
                }
            }
        },

        remove(e) {
            e.stopPropagation();
            e.preventDefault();
            this.form.tags = [];
            this.$emit('removeFilter');
        },

        changeValueFilter(type) {
            this.$emit('changeValueFilter', {
                filter: this.filter,
                type: type,
            });
        },

        dropdownItem(item, escape) {
            let escapedLabel = item.label.replace(/(<([^>]+)>)/gi, '');
            return `<div class="selectize-contact tag is-small is-success">
                        ${escapedLabel}
                    </div>`;
        },

        dropdownOption(item, escape) {
            let escapedLabel = item.label.replace(/(<([^>]+)>)/gi, '');

            return `<div class="selectize-contact">
                <div class="selectize-contact-info">
                    <span class="hubspot-list-name hubspot-list-name-broadcast">${escapedLabel}&nbsp;</span>
                 </div>
            </div>`;
        },

        hubSpotDropdownItem(item, escape) {
            const size = item.size ? item.size : 0;

            return `<div class="selectize-contact">
                        <span class="hubspot-list-name">${item.label}&nbsp;</span>
                        <span class="hubspot-list-size">(${size})</span>
                    </div>`;
        },

        hubSpotDropdownOption(item, escape) {
            const size = item.size ? item.size : 0;

            return `<div class="selectize-contact">
                <div class="selectize-contact-info">
                    <span class="hubspot-list-name hubspot-list-name-broadcast">${item.label}&nbsp;</span>
                    <span class="hubspot-list-size">(${size})</span>
                 </div>
            </div>`;
        },
    },

    mounted() {
        this.init();
    },
};
</script>
